import { render, staticRenderFns } from "./ModulePostcardMain.vue?vue&type=template&id=ecfe96fa&scoped=true&"
import script from "./ModulePostcardMain.vue?vue&type=script&lang=js&"
export * from "./ModulePostcardMain.vue?vue&type=script&lang=js&"
import style0 from "./ModulePostcardMain.vue?vue&type=style&index=0&id=ecfe96fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfe96fa",
  null
  
)

export default component.exports